module.exports = __webpack_public_path__ + "static/treinamento-programa-6dcbf10fff47682f55463c0dfed667d4.jpg";